import { render } from "./cornerLogo.vue?vue&type=template&id=f509505e"
import script from "./cornerLogo.vue?vue&type=script&lang=js"
export * from "./cornerLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__